import {Injectable, InjectionToken} from '@angular/core';
import {take} from 'rxjs/operators';
import {AuditId, ProjectId, TestObjectId} from '@webmate-web-core/shared/types/ids';
import {CurrentProjectService} from '@webmate-web-core/shared/services/current-project.service';
import {WorkbenchOpenService} from '@webmate-web-core/shared/workbench-ipc';

export interface OpenTestObjectInExpeditionRequest {
    testObjectId: TestObjectId;
    projectId?: ProjectId;
    auditId?: AuditId;
}

export interface TestObjectExpeditionOpener {
    open(request: OpenTestObjectInExpeditionRequest): void;
}

export const TESTOBJECT_EXPEDITION_OPENER =
    new InjectionToken<TestObjectExpeditionOpener>('TESTOBJECT_EXPEDITION_OPENER');

/**
 * The strategy for opening a TestObject in webmate is to open (or focus) the workbench, which then
 * starts/reuses the corresponding browser session and drives the TestObject in it.
 */
@Injectable({
    providedIn: 'root'
})
export class WebmateTestObjectExpeditionOpenerService implements TestObjectExpeditionOpener {
    constructor(
        private readonly currentProjectService: CurrentProjectService,
        private readonly workbenchOpenService: WorkbenchOpenService,
    ) {}

    open(request: OpenTestObjectInExpeditionRequest): void {
        const projectId = request.projectId ?? this.currentProjectService.getCurrentProjectId();
        if (!projectId) {
            console.error('Could not determine project to open workbench for TestObject');
            return;
        }

        this.workbenchOpenService.openWorkbench({
            projectId,
            auditId: request.auditId,
            openTestObjectInExpeditionConfig: {testObjectId: request.testObjectId}
        }, {
            blockedPopupMessage: 'Your browser has blocked the workbench, please allow pop-ups / new tabs for this webpage!'
        }).pipe(take(1)).subscribe();
    }
}
